import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { EventId, TeamCode } from 'common/src/generated/types';
import * as React from 'react';
import { RightPanel } from '../../designSystem/components/rightPanel/rightPanel';
import { RightPanelBody } from '../../designSystem/components/rightPanel/rightPanelBody';
import { RightPanelHeader } from '../../designSystem/components/rightPanel/rightPanelHeader';
import { useHeavent } from '../../hooks/useHeavent';
import { TeamRightPanelContextProvider, useTeamRightPanelContext } from './teamRightPanelContext';
import { TeamRightPanelPositionsSlots } from './teamRightPanelPositionsSlots';

interface ITeamRightPanelInnerProps {
    teamCode: TeamCode;

    onClose(): void;
}

const TeamRightPanelInner = (props: ITeamRightPanelInnerProps) => {
    const { translate } = useHeavent();
    const { form, loader } = useTeamRightPanelContext();

    return (
        <RightPanel size="md" onClose={props.onClose}>
            <RightPanelHeader>
                <Flex direction="column" gap="1">
                    <Box>{translate('_quipe_1_19590', props.teamCode)}</Box>

                    <Box color="gray500" fontSize="textSm">
                        {translate('formulaire_1_39637', form?.name)}
                    </Box>
                </Flex>
            </RightPanelHeader>

            <RightPanelBody css={{ background: '$gray50', py: '$6' }}>
                {loader || <TeamRightPanelPositionsSlots />}
            </RightPanelBody>
        </RightPanel>
    );
};

interface ITeamRightPanelProps {
    eventId: EventId;
    teamCode: TeamCode;

    onClose(): void;
}

export const TeamRightPanel = (props: ITeamRightPanelProps) => (
    <TeamRightPanelContextProvider eventId={props.eventId} teamCode={props.teamCode}>
        <TeamRightPanelInner {...props} />
    </TeamRightPanelContextProvider>
);
